import React from 'react';
import { Helmet } from 'react-helmet';
import Ticket from "../../blocks/ticket/Ticket";
import './assets/css/index.css';
import TriangleAnimated from "../../blocks/triangle/TriangleAnimated";
import PagePreloader from "../../helpers/PagePreloader";
import { withTranslation } from 'react-i18next';

import Festival2019 from "./assets/images/alba-festival-history-2019.jpg";
import Festival2021 from "./assets/images/alba-festival-history-2021.jpg";
import Festival2022 from "./assets/images/alba-festival-history-2022.jpg";
import Festival2024 from "./assets/images/alba-history-2024.jpg";
import Festival2025 from "./assets/images/alba-history-2025.jpg";
import Festival2026 from "./assets/images/alba-history-2026.jpg";

class History extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.setState({ loading: false });
  }

  render() {
    const { t, pageTitle } = this.props;
    // Mapping of festival years to external YouTube aftermovie links
    const aftermovieLinks = {
      "2019": "https://www.youtube.com/watch?v=IiMgKXfU4tA",
      "2022": "https://www.youtube.com/watch?v=nQiImAM3q8k",
      "2024": "https://www.youtube.com/watch?v=9wlD4fJWAC4",
      "2025": "https://www.youtube.com/watch?v=JH36P2iBjEk",
      "2026": "https://www.youtube.com/watch?v=gF7iX1X6fnY"
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>{pageTitle}</title>
        </Helmet>

        <section id="history" className="inner-wrapper">
          <h1>{t('Gallery')}</h1>
          <TriangleAnimated right />
          <TriangleAnimated left />
          <TriangleAnimated right bottom />
          <TriangleAnimated left bottom />

          <div className="container">
            <div className="body">
              {t('Entdecke die besten Impressionen des vergangenen Festivals.')}
            </div>
          </div>

          <div className="container mb-5">
            <div className="row gy-4">
              {/* Festival 2026 */}
              <div className="col-sm-6 col-md-3">
                <div className="festival-item">
                  <div>
                    <img src={Festival2026} className="img-fluid" alt="Festival 2026" />
                    <h3>2026</h3>
                  </div>
                  <div className="d-grid gap-2 mt-2">
                    <a
                      href={aftermovieLinks["2026"]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      Aftermovie
                    </a>
                    <a
                      href="https://amqjf.wfolio.pro/disk/alba-festival-2026-h0xgqt"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                    >
                      Gallery
                    </a>
                  </div>
                </div>
              </div>

              {/* Festival 2025 */}
              <div className="col-sm-6 col-md-3">
                <div className="festival-item">
                  <div>
                    <img src={Festival2025} className="img-fluid" alt="Festival 2025" />
                    <h3>2025</h3>
                  </div>
                  <div className="d-grid gap-2 mt-2">
                    <a
                      href={aftermovieLinks["2025"]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      Aftermovie
                    </a>
                    <a
                      href="https://amqjf.wfolio.pro/disk/alba-festival/2025"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                    >
                      Gallery
                    </a>
                  </div>
                </div>
              </div>

              {/* Festival 2024 */}
              <div className="col-sm-6 col-md-3">
                <div className="festival-item">
                  <div>
                    <img src={Festival2024} className="img-fluid" alt="Festival 2024" />
                    <h3>2024</h3>
                  </div>
                  <div className="d-grid gap-2 mt-2">
                    <a
                      href={aftermovieLinks["2024"]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      Aftermovie
                    </a>
                    <a
                      href="https://amqjf.wfolio.pro/disk/alba-festival/2024"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                    >
                      Gallery
                    </a>
                  </div>
                </div>
              </div>

              {/* Festival 2022 */}
              <div className="col-sm-6 col-md-3">
                <div className="festival-item">
                  <div>
                    <img src={Festival2022} className="img-fluid" alt="Festival 2022" />
                    <h3>2022</h3>
                  </div>
                  <div className="d-grid gap-2 mt-2">
                    <a
                      href={aftermovieLinks["2022"]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      Aftermovie
                    </a>
                    <a
                      href="https://amqjf.wfolio.pro/disk/alba-festival/2022"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                    >
                      Gallery
                    </a>
                  </div>
                </div>
              </div>

              {/* Festival 2021 */}
              <div className="col-sm-6 col-md-3">
                <div className="festival-item">
                  <div>
                    <img src={Festival2021} className="img-fluid" alt="Festival 2021" />
                    <h3>2021</h3>
                  </div>
                  <div className="d-grid gap-2 mt-2">

                  </div>
                </div>
              </div>

              {/* Festival 2019 */}
              <div className="col-sm-6 col-md-3">
                <div className="festival-item">
                  <div>
                    <img src={Festival2019} className="img-fluid" alt="Festival 2019" />
                    <h3>2019</h3>
                  </div>
                  <div className="d-grid gap-2 mt-2">
                    <a
                      href={aftermovieLinks["2019"]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      Aftermovie
                    </a>

                    <a
                      href="https://amqjf.wfolio.pro/disk/alba-festival/2019"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                    >
                      Gallery
                    </a>

                  </div>
                </div>
              </div>

            </div>
          </div>

          <Ticket />
        </section>

        <PagePreloader page={this} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(History);
